import './LegalList.scss';

class LegalList {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['LegalList'] = LegalList;
export default LegalList;
